// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3H0Z8"};